import ListExtraCard from "./Extra/ListExtraCard"
import ListProductCard from "./Products/ListProductCard"
import ListVenueCard from "./Venue/ListVenueCard"
import BlockExtraCard from "./Extra/BlockExtraCard"
import BlockProductCard from "./Products/BlockProductCard"
import BlockVenueCard from "./Venue/BlockVenueCard"
import { ProductTypes} from "../../types/product.types"
import ListActivityCard from "./Activity/ListActivityCard"
import BlockActivityCard from "./Activity/BlockActivityCard"
/**
* Props for the CardRenderer component.
*/ 
interface CardRendererProps {
    item: ProductTypes; // Items to render
    viewStyle: 'list' | 'block'; // Layout style,
    cardKey: string // Key for the rendered card
}
/**
* A component for rendering product cards.
* Renders differrent card based on type of the product and viewstyle
*
* @param props CardRendererProps
* @param {ProductTypes} props.item - Items to render
* @param {'list' | 'block'} props.viewStyle - Layout style
* @param {string} props.key - Key for the rendered card
* @returns TSX.Element
*/
const CardRenderer: React.FC<CardRendererProps> = ({item, viewStyle, cardKey }) => {
    const { type, data } = item;

    if (type === 'sales') {
        return viewStyle === 'list'
        ? <ListProductCard {...data} key={cardKey} />
        : <BlockProductCard {...data} key={cardKey} />;
    }
    
    if (type === 'new') {
        return viewStyle === 'list'
        ? <ListProductCard {...data} key={cardKey} />
        : <BlockProductCard {...data} key={cardKey} />;
    }

    if (type === 'package') {
        return viewStyle === 'list'
        ? <ListProductCard {...data} type="package" key={cardKey} />
        : <BlockProductCard {...data} type="package" key={cardKey} />;
    }

    if (type === 'activities') {
        return viewStyle === 'list'
        ? <ListActivityCard {...data} key={cardKey} />
        : <BlockActivityCard {...data} key={cardKey} />;
    }

    if (type === 'venue') {
        return viewStyle === 'list'
        ? <ListVenueCard {...data} key={cardKey} />
        : <BlockVenueCard {...data} key={cardKey} />;
    }

    if (type === 'storage') {
        return viewStyle === 'list'
        ? <ListExtraCard {...data} key={cardKey} />
        : <BlockExtraCard {...data} key={cardKey} />;
    }

    return null;
};
export default CardRenderer